// extracted by mini-css-extract-plugin
export var arrow = "CenteredCarousel-module--arrow--4d8e5";
export var arrowUpAndDown = "CenteredCarousel-module--arrow-up-and-down--3ffa5";
export var bullet = "CenteredCarousel-module--bullet--0da99";
export var bulletActive = "CenteredCarousel-module--bulletActive--b7c77";
export var carouselContainer = "CenteredCarousel-module--carouselContainer--d7ae1";
export var itemsSimpleListContainer = "CenteredCarousel-module--itemsSimpleListContainer--92cb1";
export var locked = "CenteredCarousel-module--locked--c9344";
export var navigationContainer = "CenteredCarousel-module--navigationContainer--e8ce9";
export var nextArrow = "CenteredCarousel-module--nextArrow--b2bbf";
export var paginationContainer = "CenteredCarousel-module--paginationContainer--149ad";
export var prevArrow = "CenteredCarousel-module--prevArrow--45d2d";
export var primaryColor = "CenteredCarousel-module--primaryColor--6c774";
export var swiper = "CenteredCarousel-module--swiper--da1a8";